import { render } from "./user-icon.vue.js?vue&type=template&id=268f8c44!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./user-icon.vue?vue&type=template&id=268f8c44"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__